import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import Dayschange from "./Dayschange";
import { useDispatch, useSelector } from "react-redux";
import { Form, FormCheck } from "react-bootstrap";
import { clearTimingData, getTiminglist } from "../../store/apiSlice/GetTimingSlice";
import { updateTimingslist, clearData } from "../../store/apiSlice/UpdateTimingsSlice";
import { clearDeleteData, deleteTimingslist } from "../../store/apiSlice/DeleteTimingsSlice";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

// Helper to format date in DD/MM/YYYY
const formatDateDDMMYYYY = (date) => date.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" });


const generateHourlySlots = (start, end) => {
  if (!start || !end) return [];
  const s = dayjs(start);
  const e = dayjs(end);
  const startTime = `${String(s.hour()).padStart(2, "0")}:${String(s.minute()).padStart(2, "0")}`;
  const endTime = `${String(e.hour()).padStart(2, "0")}:${String(e.minute()).padStart(2, "0")}`;
  return [startTime, endTime];
};


const Availability = () => {
  const dispatch = useDispatch();
  const getTiming = useSelector((state) => state.rootReducer.getTiminglistReducer.data);
  const updateTiming = useSelector((state) => state.rootReducer.updateTimingslistReducer.data);
  const deleteTimingReducer = useSelector((state) => state.rootReducer.deleteTimingsReducer.data);

  const [selectedTiming, setSelectedTiming] = useState([]);
  const [selectedCalenderValues, setSelectedCalenderValues] = useState([]);
  const [deleteIds, setDeleteIds] = useState([]);
  const [displayStyleMap, setDisplayStyleMap] = useState({});

  useEffect(() => {
    return () => {
      dispatch(clearTimingData());
      dispatch(clearDeleteData());
      setSelectedTiming([]);
      setSelectedCalenderValues([]);
      setDeleteIds([]);
      setDisplayStyleMap({});
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(getTiminglist(1));
  }, [dispatch]);

  useEffect(() => {
    if (getTiming?.status === 1) {
      setSelectedTiming(getTiming.data.data || []);
    }
  }, [getTiming]);

  useEffect(() => {
    if (updateTiming?.status === 1) {
      alert("Timing Updated successfully!");
      dispatch(getTiminglist(1));
      dispatch(clearData());
      setSelectedCalenderValues([]);
      setDisplayStyleMap({});
    }
  }, [updateTiming, dispatch]);

  useEffect(() => {
    if (deleteTimingReducer?.status === 1) {
      alert("Timing Deleted successfully!");
      dispatch(clearDeleteData());
      dispatch(getTiminglist(1));
      setSelectedCalenderValues((prev) => prev.filter((p) => !deleteIds.includes(p._id)));
      setDeleteIds([]);
    }
  }, [deleteTimingReducer, dispatch, deleteIds]);

  const tileClassName = ({ date }) => {
    const formatted = formatDateDDMMYYYY(date);
    const isDefaultHighlighted = selectedTiming.some((d) => d.date === formatted);
    const isHighlighted = selectedCalenderValues.some((d) => d.date === formatted);
    if (isDefaultHighlighted) return "default-highlighted-date";
    if (isHighlighted) return "highlighted-date";
  };

  const handleCalendarClick = (date) => {
    const formatted = formatDateDDMMYYYY(date);
    const existingIndex = selectedCalenderValues.findIndex((d) => d.date === formatted);
    if (existingIndex > -1) {
      // unselect
      const updated = selectedCalenderValues.filter((d) => d.date !== formatted);
      setSelectedCalenderValues(updated);
      setDisplayStyleMap((prev) => {
        const copy = { ...prev };
        delete copy[formatted];
        return copy;
      });
      return;
    }
    const backendItem = selectedTiming.find((t) => t.date === formatted);
    if (backendItem) {
      // const slots = Array.isArray(backendItem.timeSlotsAvailablity)
      //   ? backendItem.timeSlotsAvailablity[0] ? backendItem.timeSlotsAvailablity[0].split(', ') : []
      //   : typeof backendItem.timeSlotsAvailablity === "string"
      //     ? backendItem.timeSlotsAvailablity.split(",")
      //     : [];


      let slots = [];

      if (backendItem?.timeSlotsAvailablity) {
        const raw =
          Array.isArray(backendItem.timeSlotsAvailablity)
            ? backendItem.timeSlotsAvailablity[0]
            : backendItem.timeSlotsAvailablity;

        slots = typeof raw === "string"
          ? raw.split(/\s*,\s*/).filter(Boolean)
          : [];
      }


      const startTime = slots.length > 0 && slots[0] ? dayjs(`${slots[0]}`, "HH:mm") : null;
      const endTime = slots.length > 0 && slots[1] ? dayjs(`${slots[1]}`, "HH:mm") : null;
      setSelectedCalenderValues((prev) => [
        ...prev,
        {
          _id: backendItem._id,
          date: backendItem.date,
          day: backendItem.day?.toString() ?? (new Date(swappedDateString(backendItem.date)).getDay().toString()),
          isFullDayAvialable: backendItem.isFullDayAvialable ?? 1,
          startTime: startTime,
          endTime: endTime,
          timeSlotsAvailablity: slots,
        },
      ]);
      setDisplayStyleMap((prev) => ({ ...prev, [formatted]: backendItem.isFullDayAvialable === 1 ? "none" : "block" }));
      return;
    }

    setSelectedCalenderValues((prev) => [
      ...prev,
      {
        date: formatted,
        day: date.getDay().toString(),
        isFullDayAvialable: 1,
        startTime: null,
        endTime: null,
        timeSlotsAvailablity: [],
      },
    ]);
    setDisplayStyleMap((prev) => ({ ...prev, [formatted]: "none" }));
  };

  const swappedDateString = (originalDate) => {
    if (!originalDate) return "";
    const [dd, mm, yyyy] = originalDate.split("/");
    return `${mm}/${dd}/${yyyy}`;
  };

  const updateClick = () => {
    for (let sel of selectedCalenderValues) {
      if (!sel.isFullDayAvialable) {
        if (!sel.startTime || !sel.endTime) {
          alert(`Please select both start and end time for ${sel.date}`);
          return;
        }
        if (sel.startTime.isSame(sel.endTime) || sel.startTime.isAfter(sel.endTime)) {
          alert(`Invalid time range for ${sel.date}: Start time must be before End time`);
          return;
        }
      }
    }
    const map = new Map();

    (selectedTiming || []).forEach((item) => {
      map.set(item.date, {
        ...item,
        timeSlotsAvailablity: Array.isArray(item.timeSlotsAvailablity)
          ? item.timeSlotsAvailablity
          : typeof item.timeSlotsAvailablity === "string"
            ? item.timeSlotsAvailablity.split(",").map(t => t.trim()).filter(Boolean)
            : [],
      });
    });

    selectedCalenderValues.forEach((sel) => {
      // Only store start and end as a single string in an array
      const slotsFromRange =
        sel.startTime && sel.endTime
          ? [`${String(sel.startTime.hour()).padStart(2, "0")}:${String(sel.startTime.minute()).padStart(2, "0")}, ${String(sel.endTime.hour()).padStart(2, "0")}:${String(sel.endTime.minute()).padStart(2, "0")}`]
          : [];

      const isFullDay = sel.isFullDayAvialable === 1;

      map.set(sel.date, {
        date: sel.date,
        day: sel.day || String(new Date(swappedDateString(sel.date)).getDay()),
        timeSlotsAvailablity: isFullDay ? [] : slotsFromRange,
        isFullDayAvialable: isFullDay ? 1 : slotsFromRange.length > 0 ? 0 : 1,
        isDaySchedule: 0,
      });
    });

    const mergedByDate = Array.from(map.values()).map((v) => ({
      date: v.date,
      day: String(v.day),
      timeSlotsAvailablity: v.isFullDayAvialable ? [] : Array.isArray(v.timeSlotsAvailablity) ? v.timeSlotsAvailablity : [],
      isFullDayAvialable: v.isFullDayAvialable ? 1 : 0,
      isDaySchedule: 0,
      ...(v._id ? { _id: v._id } : {}),
    }));

    const payload = { timings: mergedByDate };
    dispatch(updateTimingslist(payload));
  };

  const deleteTiming = () => {
    const idsToDelete = selectedCalenderValues.map((d) => d._id).filter(Boolean);
    if (idsToDelete.length === 0) {
      alert("No existing timing selected to delete. Select a date that already exists and then delete.");
      return;
    }
    setDeleteIds(idsToDelete);
    dispatch(deleteTimingslist({ ids: idsToDelete }));
  };

  const toggleFullDayForDate = (dateStr, checked) => {
    setSelectedCalenderValues((prev) => prev.map((p) => (p.date === dateStr ? { ...p, isFullDayAvialable: checked ? 1 : 0 } : p)));
    setDisplayStyleMap((prev) => ({ ...prev, [dateStr]: checked ? "none" : "block" }));
  };
  return (
    <div className="order_card mb-5 calender">
      <Tabs
        onSelect={(index) => {
          dispatch(clearData());
          dispatch(clearTimingData());
          dispatch(getTiminglist(index + 1));
        }}
      >
        <div className="d-flex justify-content-between">
          <TabList>
            <Tab>CALENDER</Tab>
            <Tab>DAYS</Tab>
          </TabList>
        </div>

        <TabPanel>
          <div className="mt-3">
            <div className="updates">
              {selectedCalenderValues.some((d) => d._id) && (
                <button type="button" className="update_btn me-2 delete_btn_red" onClick={deleteTiming}>
                  Delete Selected Existing
                </button>
              )}
              <button type="button" className="update_btn" onClick={updateClick}>
                Update
              </button>
            </div>

            <Calendar tileClassName={tileClassName} onClickDay={handleCalendarClick} />

            <div className="mt-3">
              <p>Selected dates:</p>
              {selectedCalenderValues.length === 0 && <p>Please select one or more dates</p>}
              {selectedCalenderValues.map((sel) => (
                <div key={sel.date} className="card p-2 mb-2">
                  <div className="d-flex justify-content-between align-items-center">
                    <strong>{sel.date}</strong>
                    <div className="d-flex align-items-center ">
                      <Form>
                        <FormCheck
                          type="switch"
                          label="Full day"
                          checked={sel.isFullDayAvialable === 1}
                          onChange={(e) => toggleFullDayForDate(sel.date, e.target.checked)}
                        />
                      </Form>
                    </div>
                  </div>

                  <div style={{ display: displayStyleMap[sel.date] === "block" ? "block" : "none", "marginTop": "8px" }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <div className="d-flex gap-2 align-items-center">
                        <TimePicker
                          label="Start Time"
                          value={sel.startTime || null}
                          onChange={(newValue) =>
                            setSelectedCalenderValues((prev) => prev.map((p) => (p.date === sel.date ? { ...p, startTime: newValue } : p)))
                          }
                          ampm={false}
                        />
                        <TimePicker
                          label="End Time"
                          value={sel.endTime || null}
                          onChange={(newValue) => {
                            setSelectedCalenderValues((prev) => prev.map((p) => (p.date === sel.date ? { ...p, endTime: newValue } : p)))
                          }}
                          ampm={false}
                        />
                      </div>
                    </LocalizationProvider>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </TabPanel>

        <TabPanel>
          <Dayschange />
        </TabPanel>
      </Tabs>
    </div>
  );
};

export default Availability;
